"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const IC_RIGHT_1 = __importDefault(require("../../../assets/icons/IC_RIGHT"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const scale_1 = require("../../../utils/scale");
const ItemArticles_1 = __importDefault(require("../../HomeScreen/components/ItemArticles"));
const ItemHashtag = (props) => {
    const { data, onOpenHashtag } = props;
    const [listData, setListData] = (0, react_1.useState)(data);
    const displayTweet = (data) => {
        const list = [...listData];
        list.filter((item) => item?.article_id != data);
        setListData(list);
    };
    return (react_1.default.createElement(react_native_1.View, { style: { width: '100%' } },
        react_1.default.createElement(react_native_1.View, { style: { width: '100%', paddingHorizontal: (0, scale_1.scale)(16) } },
            react_1.default.createElement(react_native_1.Pressable, { style: {
                    width: '100%',
                    flexDirection: 'row',
                    height: (0, scale_1.scale)(30),
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, onPress: onOpenHashtag },
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: {
                            flex: 1,
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: '#007AFF',
                        } }, `#${data?.hash_tag_name}`),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(11),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: '#7C7C7C',
                            marginLeft: (0, scale_1.scale)(12),
                        } }, `${data?.count}件`)),
                react_1.default.createElement(IC_RIGHT_1.default, { width: (0, scale_1.scale)(12), height: (0, scale_1.scale)(12) }))),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: { paddingRight: (0, scale_1.scale)(20) }, showsHorizontalScrollIndicator: scale_1.isPC, horizontal: true, style: {
                flexDirection: 'column',
                flexWrap: 'wrap',
                paddingLeft: (0, scale_1.scale)(16),
            } }, data.articles.map((item, index) => {
            return (react_1.default.createElement(ItemArticles_1.default, { data: item, key: index, displayTweet: (data) => displayTweet(data), displayBlock: true, showCreatedAt: true }));
        }))));
};
exports.default = ItemHashtag;
